export const isAllOptionChecked = (value) => {
    return value.includes(null) ? [null] : value
};
